import type { OvpClient } from '@bldsoft/cappie/api/ovp'
import type { WebHomePageGetOutputDto } from '@bldsoft/ovp-api-types'
import type { API } from '@setplex/tria-api'
import { payload } from '../../result'
import { format } from './format'

export function use(client: OvpClient, home: API['home'], _api: API): void {
  // GET /api/web/home-page/v2_2/{regionName}
  home.getFx.use(async (regionName) => {
    const data = payload<WebHomePageGetOutputDto>(
      await client.get.api.web.homePage.v22(regionName)
    )

    if (!data) {
      throw new Error('Empty answer in home.base.getFx')
    }

    return format(data)
  })
}
